import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import { quoteLink } from "@/data/siteData";
import { useLanguage, useLocalizedContent } from "@/i18n/LanguageContext";

export default function PersonalInsurance() {
  const { t } = useLanguage();
  const { personal } = useLocalizedContent();
  return (
    <div data-testid="personal-insurance-page">
      <Seo
        title="Personal Insurance — Motor, Health, Cyber, Home, Life | Wisdom Insurance Broking"
        description="Motor, health, cyber, home and term life insurance for individuals and families, arranged through an IRDAI-licensed broker in Pune."
        keywords="personal insurance Pune, health insurance, motor insurance, term life insurance, home insurance India"
      />

      <section className="grain bg-navy-deep pb-16 pt-32 md:pb-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <FadeIn>
            <Eyebrow light>{t("pe.eyebrow")}</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
              {t("pe.title")}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
              {t("pe.sub")}
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 md:py-20 lg:px-16">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {personal.map((p, i) => (
            <FadeIn key={p.id} delay={i * 0.07}>
              <div
                data-testid={`personal-card-${p.id}`}
                className="flex h-full flex-col border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/50 hover:shadow-xl"
              >
                <p.icon className="h-8 w-8 text-amber-600" strokeWidth={1.5} />
                <h3 className="mt-5 font-heading text-xl font-semibold text-navy">{p.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{p.line}</p>
                <Link
                  to={quoteLink(`Personal — ${p.enTitle}`)}
                  data-testid={`personal-enquire-${p.id}`}
                  className="group mt-6 inline-flex w-fit items-center gap-2 border border-navy px-5 py-2.5 text-sm font-semibold text-navy transition-colors hover:bg-navy hover:text-white"
                >
                  {t("pe.enquire")}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn className="mt-14 border border-slate-200 bg-slate-50 p-8 text-center">
          <p className="text-sm text-slate-600">
            {t("pe.unsurePre")} <Link to="/contact" data-testid="personal-contact-link" className="font-semibold text-amber-700 hover:text-amber-800">{t("pe.unsureLink")}</Link> {t("pe.unsurePost")}
          </p>
        </FadeIn>
      </section>
    </div>
  );
}
